import { Map, List, fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

export const FETCH_SITES = 'dashboard/FETCH_SITES'
export const FETCH_SITE = 'dashboard/FETCH_SITE'
export const FETCH_DASHBOARD_SITE_TYPE = 'dashboard/FETCH_DASHBOARD_SITE_TYPE'
export const [
  FETCH_DASHBOARD_SITE_TYPE_SUCCESS,
  FETCH_DASHBOARD_SITE_TYPE_FAILURE,
] = [
  `${FETCH_DASHBOARD_SITE_TYPE}_SUCCESS`,
  `${FETCH_DASHBOARD_SITE_TYPE}_FAILURE`,
]
export const DISPLAY_SITES = 'dashboard/DISPLAY_SITES'
export const RESET_DASHBOARD_STATE = 'dashboard/RESET_STATE'
export const DASHBOARD_MAP_OPEN_INFOWINDOW = 'dashboard/MAP_OPEN_INFOWINDOW'
export const DASHBOARD_MAP_CLOSE_INFOWINDOW = 'dashboard/MAP_CLOSE_INFOWINDOW'
export const FETCH_STATISTIC_DATA = 'dashboard/FETCH_STATISTIC_DATA'
export const SET_STATISTIC_DATA = 'dashboard/SET_STATISTIC_DATA'
export const OPEN_SIDE_PANEL = 'dashboard/OPEN_SIDE_PANEL'
export const CLOSE_SIDE_PANEL = 'dashboard/CLOSE_SIDE_PANEL'

export const fetchSites = ActionHelper.createActionObj(FETCH_SITES)
export const fetchSite = ActionHelper.createActionObj(FETCH_SITE)
export const fetchSiteType = ActionHelper.createActionObj(
  FETCH_DASHBOARD_SITE_TYPE,
)
export const resetDashboard = ActionHelper.createActionObj(
  RESET_DASHBOARD_STATE,
)
export const dashboardMapCloseInfoWindow = ActionHelper.createActionObj(
  DASHBOARD_MAP_CLOSE_INFOWINDOW,
)
export const fetchStatisticData = ActionHelper.createActionObj(
  FETCH_STATISTIC_DATA,
)
export const openSidePanel = ActionHelper.createActionObj(OPEN_SIDE_PANEL)
export const closeSidePanel = ActionHelper.createActionObj(CLOSE_SIDE_PANEL)

const initialState = fromJS({
  activeMarker: {
    isDefault: true,
    site: {
      name: '',
      unitId: '',
      siep: '',
      dateCreated: '',
      location: {
        latitude: '',
        longitude: '',
      },
    },
    mortality: 0,
  },
  sites: [],
  statistic: {},
  types: [],
  isOpenSidePanel: false,
})

const dashboard = handleActions(
  {
    [OPEN_SIDE_PANEL]: state => state.set('isOpenSidePanel', true),
    [CLOSE_SIDE_PANEL]: state => state.set('isOpenSidePanel', false),
    [DISPLAY_SITES]: (state, action) => state.set('sites', List(action.sites)),
    [FETCH_DASHBOARD_SITE_TYPE_SUCCESS]: (state, action) =>
      state.set('types', List(action.types)),
    [SET_STATISTIC_DATA]: (state, action) =>
      state.set('statistic', Map(action.statistic)),
    [combineActions(RESET_DASHBOARD_STATE, RESET_STORE)]: () => initialState,
    [DASHBOARD_MAP_OPEN_INFOWINDOW]: (state, action) =>
      state.set('activeMarker', Map(action.payload)),
    [DASHBOARD_MAP_CLOSE_INFOWINDOW]: state =>
      state.set('activeMarker', initialState.get('activeMarker')),
  },
  initialState,
)

export default dashboard
